import { render, staticRenderFns } from "./Outro.vue?vue&type=template&id=67b9244a"
var script = {}
import style0 from "./Outro.vue?vue&type=style&index=0&id=67b9244a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports